import api from '../config/api';

export const getPublishedEvents = async () => {
  const res = await api.get('/events');
  return res.data;
};

export const getEventById = async (id) => {
  const res = await api.get(`/events/${id}`);
  return res.data;
};

// Staff endpoints
export const listAllEvents = async (params) => {
  const res = await api.get('/staff/events', { params });
  return res.data;
};

export const createEvent = async (payload) => {
  const res = await api.post('/staff/events', payload);
  return res.data;
};

export const updateEvent = async (id, payload) => {
  const res = await api.put(`/staff/events/${id}`, payload);
  return res.data;
};

export const deleteEvent = async (id) => {
  const res = await api.delete(`/staff/events/${id}`);
  return res.data;
};
